if (!customElements.get('jersey-customizer')) {
    customElements.define('jersey-customizer', class JerseyCustomizer extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.form = this.closest("product-form").querySelector('form[action*="/cart/add"]');
            this.initElements();
            this.bindEvents();
        }

        initElements() {
            this.mainToggle = this.querySelector('[data-main-toggle]');
            this.bodyContainer = this.querySelector('[data-customization-body]');
            this.printingInputs = this.querySelectorAll('[data-printing-input]');
            this.numberInput = this.querySelector("input[data-number-input]");
            this.badgeAccentPrice = this.querySelector(".jc-badges-section .jc-price-accent");
            this.badgeCheckboxes = this.querySelectorAll('[data-badge-checkbox]');
            this.badgesHiddenInput = this.querySelector('[data-badges-hidden-input]');
            this.badgePriceTag = this.querySelector('[data-badge-price-tag]');
            this.totalPriceEl = this.querySelector('[data-total-price]');
            this.toggleText = this.querySelector(".jc-toggle-text");

            this.printingPrice = parseInt(this.dataset.printingPrice || 0);
            this.printingVariantId = this.dataset.printingVariant;

            this.basePrice = parseInt(this.dataset.basePrice || 0);
            this.baseComparePrice = parseInt(this.dataset.baseComparePrice || 0);

            this.accordion = this.querySelector('[data-addon-accordion]');

            if (this.accordion) {
                this.accordionTrigger = this.accordion.querySelector('[data-accordion-trigger]');
                this.accordionContent = this.accordion.querySelector('[data-accordion-content]');
                this.accordionIcon = this.accordion.querySelector('[data-accordion-icon]');
                this.addPrintInput = this.accordion.querySelector('[data-add-print-input]');
            }

            if (this.form) {
                this.submitBtn = this.form.querySelector('[name="add"], [data-add-to-cart], .product-form__submit');
                this.submitBtnTextEl = this.submitBtn ? (this.submitBtn.querySelector('[data-add-to-cart-text], span') || this.submitBtn) : null;
            }
        }

        bindEvents() {
            if (this.mainToggle) {
                this.mainToggle.addEventListener('change', (e) => {
                    const toggleText = e.target.checked ? this.toggleText.getAttribute("data-with-printing") : this.toggleText.getAttribute("data-without-printing");

                    if (e.target.checked) {
                        this.bodyContainer.classList.add("opened");
                    } else {
                        this.bodyContainer.classList.remove("opened");
                    }

                    if (toggleText) {
                        this.toggleText.innerHTML = toggleText;
                    }

                    this.updateTotalCalculations();
                });
            }

            if (this.numberInput) {
                this.numberInput.addEventListener('input', (e) => {
                    e.target.value = e.target.value.replace(/\D/g, '');
                  });
            }

            this.badgeCheckboxes.forEach(cb => {
                cb.addEventListener('change', (e) => {
                    const card = e.target.closest('[data-badge-card]');
                    card.classList.toggle('is-selected', e.target.checked);
                    this.updateBadgesData();
                    this.updateTotalCalculations();
                });
            });

            if (this.form) {
                const variantInput = this.form.querySelector('[name="id"]');
                if (variantInput) {
                    variantInput.addEventListener('change', (e) => this.handleVariantChange(e));
                }

                this.querySelector("input[name='properties[Name]']").addEventListener("input", function () {
                   if (this.classList.contains("is-invalid")) this.classList.remove("is-invalid");
                });

                this.querySelector("input[name='properties[Number]']").addEventListener("input", function () {
                    if (this.classList.contains("is-invalid")) this.classList.remove("is-invalid");
                 });

                this.accordionContent.querySelector(".jc-input").addEventListener("input", function () {
                    if (this.classList.contains("is-invalid")) this.classList.remove("is-invalid");
                });

                window.addEventListener('theme:variant:prices-updated', (e) => {
                    if (e.detail && e.detail.variant) {
                        this.basePrice = e.detail.variant.price;
                        this.baseComparePrice = e.detail.variant.compare_at_price || 0;
                        this.updateTotalCalculations();
                    }
                });

                this.form.addEventListener('submit', (e) => this.handleSubmit(e));
            }

            if (this.accordionTrigger) {
                this.accordionTrigger.addEventListener('click', () => {
                    const isOpen = this.accordionContent.classList.contains('is-open');
            
                    if (isOpen) {
                        this.accordionContent.classList.remove('is-open');
                        this.accordionTrigger.setAttribute('aria-expanded', 'false');
                        if (this.accordionIcon) this.accordionIcon.textContent = '+';
                        if (this.addPrintInput) this.addPrintInput.value = '';
                    } else {
                        this.accordionContent.classList.add('is-open');
                        this.accordionTrigger.setAttribute('aria-expanded', 'true');
                        this.accordionContent.querySelector(".jc-input").classList.remove("is-invalid");
                        if (this.accordionIcon) this.accordionIcon.textContent = '-';
                        if (this.addPrintInput) this.addPrintInput.focus();
                    }
                    this.updateTotalCalculations();
                });
            }
            
            if (this.addPrintInput) {
                this.addPrintInput.addEventListener('input', () => {
                    this.updateTotalCalculations();
                });
            }
        }

        handleVariantChange(e) {
            const selectedOption = e.target.options ? e.target.options[e.target.selectedIndex] : null;
            if (selectedOption && selectedOption.dataset.price) {
                this.basePrice = parseInt(selectedOption.dataset.price);
                this.updateTotalCalculations();
            }
        }

        updateBadgesData() {
            const selected = Array.from(this.badgeCheckboxes).filter(cb => cb.checked);

            if (this.badgesHiddenInput) {
                this.badgesHiddenInput.value = selected.map(cb => cb.value).join(', ');
            }

            if (this.badgePriceTag) {
                this.badgePriceTag.classList.toggle('is-active', selected.length > 0);
            }

            if (this.badgeAccentPrice) {
                this.badgeAccentPrice.classList.toggle('is-selected', selected.length > 0);

                if (selected.length) {
                    const totalPrice = selected.reduce((val, badge) => {
                        const price = badge.getAttribute("data-price");

                        return val + (+price / 100);
                    }, 0)

                    this.badgeAccentPrice.querySelector(".selected-badges").innerHTML = "+" + this.formatMoney(totalPrice * 100);
                }
            }
        }

        formatMoney(cents) {
            const euros = (cents / 100).toFixed(2).replace('.', ',');
            return `€${euros}`;
        }

        updateTotalCalculations() {
            let extraPrice = 0;

            if (this.mainToggle && this.mainToggle.checked) {
                extraPrice += this.printingPrice;
            } else {
                this.badgeCheckboxes.forEach(cb => {
                    cb.checked = false;
                    cb.closest('[data-badge-card]').classList.remove('is-selected');
                });

                if (this.accordionContent) {
                    this.accordionContent.classList.remove('is-open');
                    this.accordionTrigger.checked = false
                    if (this.accordionTrigger) this.accordionTrigger.setAttribute('aria-expanded', 'false');
                    if (this.accordionIcon) this.accordionIcon.textContent = '+';
                    if (this.addPrintInput) this.addPrintInput.value = '';
                }

                this.updateBadgesData();
            }

            this.badgeCheckboxes.forEach(cb => {
                if (cb.checked) {
                    extraPrice += parseInt(cb.dataset.price || 0);
                }
            });

            if (this.accordionContent && this.accordionContent.classList.contains('is-open')) {
                const addPrintPrice = parseInt(this.addPrintInput?.dataset.price || 0);
                extraPrice += addPrintPrice;
            }

            if (this.totalPriceEl) {
                this.totalPriceEl.textContent = "+" + this.formatMoney(extraPrice);
            }

            // this.updateAddToCartButton(extraPrice);

            this.dispatchEvent(new CustomEvent('jersey:price-change', {
                detail: { extraPrice, newTotalPrice: this.basePrice + extraPrice },
                bubbles: true
            }));
        }

        updateAddToCartButton(extraPrice) {
            if (!this.submitBtn) return;

            const newMainPrice = this.basePrice + extraPrice;
            const formattedMainPrice = this.formatMoney(newMainPrice);

            let priceHtml = formattedMainPrice;
            if (this.baseComparePrice > this.basePrice) {
                const formattedComparePrice = this.formatMoney(this.baseComparePrice + extraPrice);
                priceHtml = `${formattedMainPrice} <s class="jc-btn-compare-price">${formattedComparePrice}</s>`;
            }

            const btnPriceEl = this.submitBtn.querySelector('.btn-state-price, [data-button-price], .product-form__submit-price');

            if (btnPriceEl) {
                btnPriceEl.innerHTML = priceHtml;
            } else if (this.submitBtnTextEl) {
                const buttonActionText = window.theme?.strings?.addToCart || 'ADD TO CART';
                this.submitBtnTextEl.innerHTML = `${buttonActionText} • ${priceHtml}`;
            }
        }

        async handleSubmit(e) {
            if (!this.mainToggle || !this.mainToggle.checked) return;

            const mainVariantId = this.form.querySelector('[name="id"]')?.value;
            if (!mainVariantId) return;

            const itemsPayload = [];
            const formData = new FormData(this.form);
            const quantitySelector = this.closest("product-form")?.querySelector(".quantity__selector");
            const quantity = quantitySelector ? +quantitySelector.value : 1;
            const playerName = this.querySelector("input[name='properties[Name]']");
            const playerNumber = this.querySelector('input[name="properties[Number]"]');
            const parentId = `bundle_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`;
            const badges = this.badgesHiddenInput.value;
            const mainProperties = { '_parent_id': parentId };
            const isAccordionOpen = this.accordionContent && this.accordionContent.classList.contains('is-open');
            const addPrintValue = this.addPrintInput?.value?.trim();

            if (!playerName?.value || !playerNumber?.value) {

                if (!playerName?.value) {
                    playerName.classList.add("is-invalid");
                }

                if (!playerNumber?.value) {
                    playerNumber.classList.add("is-invalid");
                }

                return;
            }

            if (isAccordionOpen && !addPrintValue) {
                this.accordionContent.querySelector(".jc-input")?.classList?.add("is-invalid");

                return;
            }

            if (playerName?.value) {
                mainProperties['Name'] = playerName.value;
            }

            if (playerNumber?.value) {
                mainProperties['Number'] = playerNumber?.value;
            }

            if (badges) {
                mainProperties['Badges'] = badges;
            }

            if (isAccordionOpen && addPrintValue) {
                mainProperties['Print Under Number'] = addPrintValue;
            }

            itemsPayload.push({
                id: mainVariantId,
                quantity: quantity || 1,
                properties: mainProperties
            });

            if (this.printingVariantId) {
                const printingProperties = { 
                    '_parent_id': parentId,
                    '_add_on_type': 'Player'
                };

                if (playerName?.value) {
                    printingProperties['Name'] = playerName.value;
                }
    
                if (playerNumber?.value) {
                    printingProperties['Number'] = playerNumber?.value;
                }

                itemsPayload.push({
                    id: this.printingVariantId,
                    properties: printingProperties,
                    quantity: 1
                });
            }

            if (isAccordionOpen && addPrintValue) {
                const addPrintVariantId = this.addPrintInput?.dataset.variantId;
                if (addPrintVariantId) {
                    itemsPayload.push({
                        id: addPrintVariantId,
                        quantity: 1,
                        properties: {
                            '_parent_id': parentId,
                            '_add_on_type': 'AdditionalPrint',
                            'Print Under Number': addPrintValue
                        }
                    });
                }
            }

            this.badgeCheckboxes.forEach(cb => {
                if (cb.checked) {
                    itemsPayload.push({
                        id: cb.dataset.variantId,
                        properties: { 
                            '_parent_id': parentId,
                            '_add_on_type': 'Badge'
                        },
                        quantity: 1
                    });
                }
            });

            try {
                if (this.submitBtn) {
                    this.submitBtn.classList.add('is-loading');
                    this.submitBtn.setAttribute('disabled', true);
                }

                let response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: itemsPayload })
                });

                if (response.ok) {
                    response = await response.json();

                    const freeShippingProgressBar = document.querySelector("#cart-drawer cart-progress-bar");

                    if (freeShippingProgressBar && freeShippingProgressBar.verifyGiftItem) {
                      const giftVariantId = freeShippingProgressBar.getAttribute("data-gift-variant-id");
                      const giftThreshold = +freeShippingProgressBar.getAttribute("data-gift-threshold");
            
                      if (giftThreshold && giftVariantId) {
                        await freeShippingProgressBar.verifyGiftItem();
                      }
                    }

                    document.dispatchEvent(new CustomEvent('theme:cart-bar:reset-atc-animation', {bubbles: true}));

                    this.submitBtn.classList.remove('is-loading');
                    this.submitBtn.classList.add('is-success');
      
                    setTimeout(() => {
                      this.submitBtn.removeAttribute('disabled');
                      this.submitBtn.classList.remove('is-success');
                    }, 1000);

                    document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
                }
            } catch (err) {
                console.error('Error adding customized jersey:', err);
            } finally {
                if (this.submitBtn) this.submitBtn.classList.remove('loading');
            }
        }
    });
}